<ion-app style="align-content: center">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
